import React, { useState, useEffect, useRef } from "react";

import klimateRideLive from "../../images/klimateRiveLive.webp";
import laja from "../../images/laja.webp";
import Realtypros from "../../images/Realtypros.webp";
import Goodseed from "../../images/Goodseed.webp";
const AD_DURATION = 20000;

const ads = [
  {
    id: "klimate-ride",
    kind: "image",
    image: klimateRideLive,
    title: "KlimateRide: Move with Confidence Ride with Purpose",
    description:
      "We're excited to launch a new travel platform that promotes eco-friendly trips. Our aim is to lower carbon footprints and build a community committed to caring for the Earth.",
    brand: "KlimateRide",
  },
  {
    id: "drive-video-2",
    kind: "video",
    video:
      "https://drive.google.com/file/d/1yqvT8a27MbOHfZ66lkOoGqnc8WjWYxsB/view",
    title: "Become a klimateRide driver",
    description: "",
    brand: "CloseCarbon",
    cta: "Learn More",
    link: "/",
  },
  {
    id: "laja",
    kind: "image",
    image: laja,
    title: "Laja Shoniran: AI for Everyday People",
    description:
      "Does it seems like AI is moving faster than you can keep up? You don’t need 28days or technical background to understand and use AI confidently.",
    brand: "Laja Shoniran",
  },
  {
    id: "Realtypros",
    kind: "image",
    image: Realtypros,
    title: "Realtypros LGL(CSMO): Buy To Flip",
    description:
      "Buy 2 bedroom at twin court for 60million to buy back at 90million naira, with guaranteed  investment agreement , posted cheque and payment receipt",
    brand: "Realtypros lgl ",
  },
  {
    id: "Goodseed",
    kind: "image",
    image: Goodseed,
    title: "Goodseed Liquid Soap Enterprise",
    description:
      "Goodseed liquid soap is formulated to clean and refresh for general domestic purpose, and perfect for every cleaning needs.",
    brand: "Okosun Jonathan",
  },
  {
    id: "become-driver",
    kind: "video",
    video:
      "https://drive.google.com/file/d/10JuPtDwnivWgWfmPEA3uC2ZgwNZ4jvsg/view?usp=drive_link",
    poster: "/images/become-a-klimate-ride-driver-poster.png",
    title: "Share your Trip link with your contact ",
    cta: "Get Started",
    link: "/drive",
  },
];

function CloseButton({ onClick, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`h-3 w-3 flex-shrink-0 rounded-full sm:h-6 sm:w-6 ${className}`}
      aria-label="Close advertisement"
    >
      <svg
        width="24"
        height="24"
        className="h-full w-full"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#F5F5F5" />
        <path
          d="M16.2824 7.71509L7.71094 16.2865M16.2824 16.2865L7.71094 7.71509"
          stroke="black"
          strokeWidth="1.07143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

function AccountIcon() {
  return (
    <svg
      width="24"
      height="24"
      className="h-3 w-3 flex-shrink-0 sm:h-6 sm:w-6"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
        fill="#898989"
      />
    </svg>
  );
}

function ArrowRightIcon({ color = "#0D924F", className = "" }) {
  return (
    <svg
      width="24"
      height="24"
      className={`h-3 w-3 sm:h-6 sm:w-6 ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.47 6.47007C12.6106 6.32962 12.8012 6.25073 13 6.25073C13.1988 6.25073 13.3894 6.32962 13.53 6.47007L18.53 11.4701C18.6705 11.6107 18.7493 11.8013 18.7493 12.0001C18.7493 12.1988 18.6705 12.3894 18.53 12.5301L13.53 17.5301C13.4613 17.6038 13.3785 17.6629 13.2865 17.7039C13.1945 17.7448 13.0952 17.7669 12.9945 17.7687C12.8938 17.7704 12.7938 17.7519 12.7004 17.7142C12.607 17.6765 12.5222 17.6203 12.451 17.5491C12.3797 17.4779 12.3236 17.3931 12.2859 17.2997C12.2482 17.2063 12.2296 17.1063 12.2314 17.0056C12.2332 16.9048 12.2552 16.8055 12.2962 16.7135C12.3372 16.6215 12.3963 16.5387 12.47 16.4701L16.19 12.7501H6C5.80109 12.7501 5.61032 12.6711 5.46967 12.5304C5.32902 12.3898 5.25 12.199 5.25 12.0001C5.25 11.8012 5.32902 11.6104 5.46967 11.4697C5.61032 11.3291 5.80109 11.2501 6 11.2501H16.19L12.47 7.53007C12.3295 7.38945 12.2507 7.19882 12.2507 7.00007C12.2507 6.80132 12.3295 6.6107 12.47 6.47007Z"
        fill={color}
      />
    </svg>
  );
}

function getDrivePreviewUrl(videoUrl) {
  try {
    const parsedUrl = new URL(videoUrl);
    const fileId =
      parsedUrl.pathname.match(/^\/file\/d\/([^/]+)/)?.[1] ??
      parsedUrl.searchParams.get("id");

    if (parsedUrl.hostname !== "drive.google.com" || !fileId) return null;

    const previewUrl = new URL(
      `https://drive.google.com/file/d/${fileId}/preview`,
    );
    previewUrl.searchParams.set("autoplay", "1");
    previewUrl.searchParams.set("mute", "1");

    return previewUrl.toString();
  } catch {
    return null;
  }
}

function ImageAd({ ad, onClose, onAdvance }) {
  return (
    <>
      <div className="hidden h-[268px] w-full min-w-0 flex-col gap-6 sm:gap-6 sm:flex">
        <div className="flex h-[58px] w-full items-start justify-between gap-4 mb-3">
          <h3 className="line-clamp-2 min-w-0 pb-2 flex-1 break-words font-medium text-[24px] leading-[29px] text-[#0D924F] ">
            {ad.title}
          </h3>
          <div onClick={onClose} className="h-6 w-6 flex-none cursor-pointer">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9161 3.97443L3.96875 11.9217M11.9161 11.9217L3.96875 3.97443"
                stroke-width="0.993414"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="black"
              />
            </svg>
          </div>
        </div>

        <div className="flex h-[186px] w-full items-end gap-4">
          <div className="flex h-[186px] w-[248px] flex-none flex-col justify-between">
            <div className="flex h-[140px] flex-col gap-4 ">
              <p className="  h-[100px] pt-3    sm:w-[246px] text-[14px] leading-[145%] text-[#898989] ">
                {ad.description}
              </p>
              <div className="flex h-6 items-center gap-3 pt-20">
                <div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 4C11.93 4 13.5 5.57 13.5 7.5C13.5 9.43 11.93 11 10 11C8.07 11 6.5 9.43 6.5 7.5C6.5 5.57 8.07 4 10 4ZM10 18C7.97 18 5.57 17.18 3.86 15.12C5.61182 13.7462 7.77376 12.9996 10 12.9996C12.2262 12.9996 14.3882 13.7462 16.14 15.12C14.43 17.18 12.03 18 10 18Z"
                      fill="#898989"
                    />
                  </svg>
                </div>

                <div className=" text-[14px] leading-[145%] text-[#898989]">
                  {ad.brand}
                </div>
              </div>
            </div>
            <button
              type="button"
              onClick={onAdvance}
              className="flex h-6 w-fit items-center gap-1 rounded-lg text-[16px] font-medium leading-[145%] text-[#0D924F]"
            >
              Next
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12H21M14.1429 6L21 12L14.1429 18"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke="#0D924F"
                />
              </svg>
            </button>
          </div>
          <img
            src={ad.image}
            alt=""
            loading="eager"
            decoding="async"
            fetchPriority={ad.id === ads[0].id ? "high" : "auto"}
            className="h-[230px] w-[220px] flex-none rounded-[7px] object-cover"
          />
        </div>
      </div>

      <div className="flex h-[124px] w-full min-w-0 flex-col overflow-visible sm:hidden">
        <div className="mb-3 flex min-h-7 w-full items-start justify-between gap-6">
          <h3 className="line-clamp-2 min-h-7 w-[185px] flex-none break-words text-[12px] font-medium leading-[14px] text-[#0D924F]">
            {ad.title}
          </h3>
          <CloseButton onClick={onClose} className="h-[10px] w-[10px] flex-none" />
        </div>

        <div className="flex h-[84px] w-full items-end gap-2 overflow-visible">
          <div className="flex h-[84px] w-[120px] flex-none flex-col justify-between">
            <div className="flex h-[63px] flex-col justify-between">
              <p className="line-clamp-3 h-[30px] w-[120px] overflow-hidden text-[8px] leading-[10px] text-[#898989]">
                {ad.description}
              </p>
              <div className="flex h-3 items-center gap-[2px]">
                <AccountIcon />
                <span className="w-[45px] truncate text-[8px] leading-[12px] text-[#898989]">
                  {ad.brand}
                </span>
              </div>
            </div>
            <button
              type="button"
              onClick={onAdvance}
              className="flex h-3 w-fit items-center gap-[2px] rounded-[4px] text-[8px] font-medium leading-[12px] text-[#0D924F]"
            >
              Next
              <ArrowRightIcon className="h-3 w-3" />
            </button>
          </div>
          <img
            src={ad.image}
            alt=""
            loading="eager"
            decoding="async"
            fetchPriority={ad.id === ads[0].id ? "high" : "auto"}
            className="h-[104px] w-[92px] flex-none rounded-[3px] object-cover"
          />
        </div>
      </div>
    </>
  );
}

function VideoAd({ ad, paused, onClose, onAdvance }) {
  const videoRef = useRef(null);
  const drivePreviewUrl = getDrivePreviewUrl(ad.video);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    if (paused) {
      v.pause();
    } else {
      v.play().catch(() => {});
    }
  }, [paused]);

  return (
    <div className="relative flex h-[124px] w-[220px] max-w-[640px] flex-none items-center justify-center overflow-hidden rounded-none  sm:h-[268px] sm:w-[484px] sm:min-w-[484px] sm:max-w-[484px] sm:rounded-lg">
      {drivePreviewUrl ? (
        <div className="absolute inset-0 overflow-hidden">
          <iframe
            src={drivePreviewUrl}
            title={ad.title}
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
            loading="eager"
            className="pointer-events-none absolute left-1/2 top-1/2 h-[124px] w-[300px] -translate-x-1/2 -translate-y-1/2 border-0 sm:h-[400%] sm:w-[400%]"
          />
        </div>
      ) : (
        <video
          ref={videoRef}
          src={ad.video}
          poster={ad.poster}
          autoPlay
          muted
          loop
          
          playsInline
          preload="auto"
          className="absolute inset-0 h-full w-full  object-cover"
        />
      )}
      <div className="pointer-events-none absolute inset-0">
        <div className="pointer-events-auto absolute left-4 top-4 max-w-[75%] break-words pb-2 text-base font-medium text-[#7BC216] [text-shadow:0_1.67px_1.67px_rgba(0,0,0,0.15)] sm:left-3 sm:top-3 sm:max-w-[277px] sm:pb-0 sm:text-4xl sm:leading-[1.2] sm:[text-shadow:0_4px_4px_rgba(0,0,0,0.15)]">
          {ad.title}
        </div>
        {/* <CloseButton
          onClick={onClose}
          className="pointer-events-auto absolute right-2 top-2 h-8 w-8 sm:right-3 sm:top-3 sm:h-6 sm:w-6"
        /> */}
        <div onClick={onClose} className="pointer-events-auto absolute right-10 p-3  top-2 h-8 w-8 sm:right-8LS sm:top-3 sm:h-6 sm:w-6">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#F5F5F5" />
            <path
              d="M16.2824 7.71509L7.71094 16.2865M16.2824 16.2865L7.71094 7.71509"
              stroke-width="1.07143"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke="black"
            />
          </svg>
        </div>
        <button
          type="button"
          onClick={onAdvance}
          className="pointer-events-auto absolute bottom-3 left-2 flex h-3 w-fit items-center gap-[2px] rounded-lg sm:bottom-6 sm:left-5 sm:h-6 sm:gap-1"
        >
          <span className="text-sm font-medium text-[#0D924F] sm:text-[16px]">
            Next
          </span>
          <span className="scale-50 sm:scale-100">
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 7H17M10.1429 1L17 7L10.1429 13"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#0D924F"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
}

function Overlaycard() {
  const [isVisible, setIsVisible] = useState(true);
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const ad = ads[index];
  const duration = ad?.duration ?? AD_DURATION;

  const handleAdvance = () => {
    setIndex((i) => (i + 1) % ads.length);
  };

  const handleHide = () => {
    setIsVisible(false);
  };

  if (!isVisible || !ad) return null;

  return (
    <>
      <style>{`
        @keyframes adProgress {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
      <div
        className={`fixed bottom-4 right-4 z-50 flex w-[244px] ${
          ad.kind === "video" ? "h-[124px] p-0 " : "h-[160px] p-3"
        } flex-col gap-0 overflow-hidden rounded-[5px] bg-white shadow-[0px_2.85px_11.82px_rgba(100,100,111,0.2)] sm:bottom-6 sm:left-auto sm:right-4 sm:h-[348px] sm:max-h-none sm:w-[min(532px,calc(100vw_-_2rem))] sm:max-w-none sm:items-start sm:gap-6 sm:overflow-visible sm:rounded-xl sm:p-6`}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onFocus={() => setPaused(true)}
        onBlur={() => setPaused(false)}
        role="complementary"
        aria-label="Advertisement"
      >
        {ad.kind === "image" ? (
          <ImageAd
            key={ad.id}
            ad={ad}
            onClose={handleHide}
            onAdvance={handleAdvance}
          />
        ) : (
          <VideoAd
            key={ad.id}
            ad={ad}
            paused={paused}
            onClose={handleHide}
            onAdvance={handleAdvance}
          />
        )}

        <div className="h-1 w-full flex-shrink-0 overflow-hidden rounded-[3px] bg-[#D9D9D9] sm:h-2 sm:rounded-lg">
          <div
            key={index}
            onAnimationEnd={handleAdvance}
            className="h-full bg-[#0D924F] rounded-lg"
            style={{
              animationName: "adProgress",
              animationDuration: `${duration}ms`,
              animationTimingFunction: "linear",
              animationFillMode: "forwards",
              animationPlayState: paused ? "paused" : "running",
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Overlaycard;